import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import IngredientsPage from '../ingredients/IngredientsPage.component'
import TemplatesAdminPage from '../templates/TemplatesAdminPage.component'
import UserSettingsForm from './UserSettingsForm.component'
import HouseholdSection from './HouseholdSection.component'
import McpKeysSection from './McpKeysSection.component'
import AdminConfigPage from './AdminConfigPage.component'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

const SettingsPage = () =>{
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const user = useSelector(state => state.auth.user);
  const isAdmin = !!(user && user.roles && user.roles.includes('ROLE_ADMIN'));

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
          <Tab label="Ingredients" {...a11yProps(0)} />
          <Tab label="Plan Templates" {...a11yProps(1)} />
          <Tab label="Account" {...a11yProps(2)} />
          {isAdmin && <Tab label="Admin" {...a11yProps(3)} />}
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <IngredientsPage />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <TemplatesAdminPage />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <UserSettingsForm />
        <HouseholdSection />
        <McpKeysSection />
      </TabPanel>
      {isAdmin &&
        <TabPanel value={value} index={3}>
          <AdminConfigPage />
        </TabPanel>}
    </div>
  );
};

export default SettingsPage;
